import { render, staticRenderFns } from "./ImprimirReporteBuroCredito.vue?vue&type=template&id=41d5ba0a&scoped=true&"
import script from "./ImprimirReporteBuroCredito.vue?vue&type=script&lang=js&"
export * from "./ImprimirReporteBuroCredito.vue?vue&type=script&lang=js&"
import style0 from "./ImprimirReporteBuroCredito.vue?vue&type=style&index=0&id=41d5ba0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d5ba0a",
  null
  
)

export default component.exports